// import { Grid } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import WSDashboardCard from "../../../Components/CardListing/WSDashboardCard";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import WSDataGridNew, { IColumns } from "../../../Components/DataGrid/WSDataGridNew";
// import { IHeaderRows } from "../../../Components/Filter/WSHeaderFilter";
// import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import { useNavigate } from "react-router-dom";

// export const PrescriptionOrder:React.FC<any>=React.memo((props)=>{
//     const navigate = useNavigate();

//   const filters = ["All", "Pending","Packed","Ready to dispatch","Out for delivery","Delivered","cancelled"];
//   const [selectedFilter, setSelectedFilter] = useState(filters[0]);

 
//   const columns: IColumns[] = [
    
  
//     {
//       header: "Patient ",
//       fieldName: "price",
//       type: "default",
//     },
//     {
//       header: "Order ID",
//       fieldName: "",
//       type: "default",
//       // sortable: true
//     },
//     {
//       header: "Price",
//       fieldName: "price",
//       type: "default",
//     },
//       {
//       header: "Items",
//       fieldName: "mode",
//       type: "default",
//     },
//     {
//       header: "Payment",
//       fieldName: "status",
//       type: "status",
//     },
//     {
//       header: "Order Date",
//       fieldName: "status",
//       type: "status",
//     },
//     {
//       header: "Status",
//       fieldName: "status",
//       type: "status",
//     },

//     {
//       header: "Actions",
//       fieldName: "actions",
//       type: "action",
//       actions: ["Edit"].filter(Boolean),
//       // actionCallback: (action, row) => handleAction(action, row),
//       // hideSelectedActions: {
//       //     fieldToHide: [
//       //         {
//       //             field: 'status',
//       //             hideValue: ['Incomplete'],
//       //             hideActions: ['Edit']
//       //         },
//       //         // {
//       //         //     field: 'profileStatus',
//       //         //     hideValue: ['Approved'],
//       //         //     hideActions: ['Approve']
//       //         // }
//       //     ]
//       // }
//     },
//   ];
//   const filterRows: IHeaderRows[] = [
//     {
//       label: "Payment",
//       fieldName: "IsProfileComplete",
//       type: "dropdown",
//       options: [
//         { label: "All", value: "true" },
//         { label: "Home", value: "false" },
//         { label: "Center", value: "false" },
//       ],
//       operator: "eq",
//       rowDivision: 3,
//     },
   
//     {
//       label: "By Date",
//       fieldName: "",
//       type: "date",
//       operator: "like",
//       rowDivision: 6,
//     },
//   ];

//   const handleClick = async () => {
//     navigate(`/lab-orders/add`);
//   };
//   return (
//     <>
       

//       <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
//         {
//           <Grid item sm={12}>
//             <WSDataGridNew
//               columns={columns}
//               id="vendorProductListGrid"
//               title="Products"
//               exportCsv={true}
//               filterFields={filterRows}
//               addButton={{ label: "New", color: "secondary" }}
//               onAddButtonClick={handleClick}
//               searchBox={{ fieldName: "name" }}
//               gridHeaderSx={{
//                 backgroundColor: "whitesmoke",
//                 border: "1px solid whitesmoke",
//               }}
//             />
//           </Grid>
//         }
//       </Grid>
//     </>
//   )
// })







import { Grid, Snackbar, Alert } from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import WSDataGridNew, { IColumns } from "../../../Components/DataGrid/WSDataGridNew";
import { IHeaderRows } from "../../../Components/Filter/WSHeaderFilter";
import { useNavigate } from "react-router-dom";
import http from "../../../commonFunctions/httpClient";
import { getLocalValue, LoacalVariables } from "../../../commonFunctions/CommonFunctions";

export const PrescriptionOrder: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  
  const [vendorId, setVendorId] = useState<string>("");
  const [prescriptionOrders, setPrescriptionOrders] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  // ✅ Snackbar State (like PharmacyOrder)
  const [snackbar, setSnackbar] = useState<{ 
    open: boolean; 
    message: string; 
    severity: 'success' | 'error' 
  }>({
    open: false,
    message: '',
    severity: 'success'
  });

  // ✅ Get vendorId from localStorage (exact PharmacyOrder pattern)
  useEffect(() => {
    const userId = getLocalValue(LoacalVariables.UserId);
    console.log("🔑 LOADED VENDOR ID:", userId);
    setVendorId(userId || "");
  }, []);

  // ✅ Fetch (exact PharmacyOrder structure)
  const fetchPrescriptionOrders = useCallback(async () => {
    if (!vendorId) {
      console.log("⏳ Waiting for vendorId...");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      console.log("📡 FETCHING PRESCRIPTION ORDERS FOR VENDOR:", vendorId);
      const response: any = await http.get(`pharmacy/PrescriptionOrder/ByVendor/${vendorId}`);
      console.log("📦 FULL API RESPONSE:", response);
      
      let data: any[] = [];
      if (response && Array.isArray(response.data)) {
        data = response.data.map((order: any) => ({
          id: order.id || order.orderId,
          orderId: `#HC${(order.orderId || order.id || '').slice(-6).toUpperCase()}`,
          patientName: order.patient?.username || order.userName || order.patientName || 'N/A',
          price: order.orderInfo?.subtotal || order.paymentInfo?.orderPrice || order.totalAmount || order.price || 0,
          itemsCount: order.orderInfo?.totalItems?.toString() || order.itemCount || order.itemsCount || '0',
          paymentStatus: order.paymentInfo?.paymentStatus || order.paymentMethod || order.paymentStatus || 'Unpaid',
          orderDate: order.timeline?.orderPlaced ? new Date(order.timeline.orderPlaced).toLocaleDateString() : 'N/A',
          status: order.timeline?.status || order.status || 'Pending',
          actions: order.id || order.orderId
        }));
      }
      
      console.log("📦 TRANSFORMED DATA:", data);
      setPrescriptionOrders(data);
    } catch (error: any) {
      console.error("💥 API ERROR:", error);
      setPrescriptionOrders([]);
      setSnackbar({
        open: true,
        message: "Failed to load prescription orders",
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  }, [vendorId]);

  useEffect(() => {
    fetchPrescriptionOrders();
  }, [fetchPrescriptionOrders]);

  // ✅ NEW: Action Handler (View/Delete)
  const handleAction = useCallback((action: string, row: any) => {
    console.log("🔧 ACTION:", action, "ROW:", row);
    
    switch (action) {
      case "View":
        navigate(`/prescription-order-details/${row.id}`);
        break;
      case "Delete":
        if (window.confirm(`Delete order ${row.orderId}?`)) {
          handleDelete(row.id);
        }
        break;
      default:
        console.log("Unknown action:", action);
    }
  }, [navigate]);

  // ✅ NEW: Delete Handler
  const handleDelete = useCallback(async (orderId: string) => {
    if (!vendorId || !orderId) return;

    try {
      console.log("🗑️ DELETING ORDER:", orderId);
      await http.del(`Delete/api/pharmacy/PrescriptionOrder/${orderId}`);
      
      // ✅ Refresh data after delete
      setPrescriptionOrders([]);
      fetchPrescriptionOrders();
      
      setSnackbar({
        open: true,
        message: `Order ${orderId} deleted successfully`,
        severity: 'success'
      });
    } catch (error: any) {
      console.error("💥 Delete Error:", error);
      setSnackbar({
        open: true,
        message: "Failed to delete order",
        severity: 'error'
      });
    }
  }, [vendorId, fetchPrescriptionOrders]);

  const handleAddClick = () => {
    navigate(`/prescription-orders/add`);
  };

  // ✅ UPDATED: Columns with View + Delete actions
  const columns: IColumns[] = [
    { header: "Patient", fieldName: "patientName", type: "default" },
    { header: "Order ID", fieldName: "orderId", type: "default" },
    { header: "Price", fieldName: "price", type: "default" },
    { header: "Items", fieldName: "itemsCount", type: "default" },
    { header: "Payment", fieldName: "paymentStatus", type: "status" },
    { header: "Order Date", fieldName: "orderDate", type: "status" },
    { header: "Status", fieldName: "status", type: "status" },

    { 
      header: "Actions", 
      fieldName: "actions", 
      type: "action", 
      actions: ["View", "Delete"],  // ✅ Added View + Delete+
      actionCallback: handleAction, // ✅ Action handler
    },
  ];

  const filterRows: IHeaderRows[] = [
    {
      label: "Payment",
      fieldName: "paymentStatus",
      type: "dropdown",
      options: [
        // { label: "All", value: "" },
        { label: "Unpaid", value: "Unpaid" },
        { label: "Paid", value: "Paid" },
        { label: "Cash", value: "Cash" },
        { label: "Online", value: "Online" },
      ],
      operator: "eq",
      rowDivision: 3,
    },
    {
      label: "By Date",
      fieldName: "orderDate",
      type: "date",
      operator: "gte",
      rowDivision: 6,
    },
  ];

  // ✅ Snackbar Close Handler
  const handleSnackbarClose = useCallback(() => {
    setSnackbar({ open: false, message: '', severity: 'success' });
  }, []);

  if (loading) {
    return (
      <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
        <Grid item sm={12} display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <div>Loading prescription orders...</div>
        </Grid>
      </Grid>
    );
  }

  if (!vendorId) {
    return (
      <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
        <Grid item sm={12} display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <div>No vendor ID found. Please login.</div>
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
        <Grid item sm={12}>
          <WSDataGridNew
            columns={columns}
            data={prescriptionOrders}
            id={`prescriptionOrderListGrid-${vendorId}`}
            title={`Prescription Orders - Vendor ${vendorId.substring(0, 8)}... (${prescriptionOrders.length})`}
            exportCsv={true}
            filterFields={filterRows}
            searchBox={{ fieldName: "patientName" }}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
            addButton={{ label: "New Order", color: "secondary" }}
            onAddButtonClick={handleAddClick}
          />
        </Grid>
      </Grid>

      {/* ✅ Snackbar Notifications (exact PharmacyOrder style) */}
      <Snackbar 
        open={snackbar.open} 
        autoHideDuration={4000} 
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert 
          onClose={handleSnackbarClose} 
          severity={snackbar.severity} 
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
});

export default PrescriptionOrder;
